
import patterns from '../patterns.json';

import { __ } from '@wordpress/i18n';
import { parse } from '@wordpress/blocks';
const Patterns = ({ isPremium, clientId, setProModalOpen }) => {

    return <> {!isPremium && <p className='noticePatter'>{__('it\'s only available on pro version', 'slider')}</p>}
        {patterns.map((pattern, index) => {
            const imgName = pattern.name.replace('/', '-');
            const imgPath = bsbInfo.patternsImagePath + imgName + '.png';
            return <div key={index} className='bsbPatters'>
                <img key={index} style={{ width: '100%' }} src={imgPath} />
                <div className="overlyButton">
                    <button onClick={() => {
                        if (isPremium) {
                            const blocks = parse(pattern.content);
                            wp.data.dispatch('core/block-editor').replaceBlock(clientId, blocks);

                        } else {
                            setProModalOpen(true);
                        }
                    }}>{__('Apply', 'slider')}</button>
                </div>
            </div>
        })}
    </>
}
export default Patterns;